




























import { Component, Vue } from 'vue-property-decorator'
import FormCard from '@/modules/login/components/common/FormCard.vue'
import UserAvatar from '@/modules/login/components/common/UserAvatar.vue'
import LoginStore from '@/modules/login/stores/LoginStore'

@Component({
  components: { FormCard, UserAvatar },
})
export default class AccessDenied extends Vue {
  get currentUser() {
    return LoginStore.currentUser
  }

  get title() {
    return `Привет${this.currentUser ? `, ${this.currentUser.firstName}` : ''}`
  }

  get errorMessage() {
    return LoginStore.ipError
  }

  showPhoneForm() {
    LoginStore.setAuthMethod(null)
  }
}
